import React from 'react';
import AvailabilityCalendar from './AvailabilityCalendar';

const MyAvailability = () => {
  return <AvailabilityCalendar isAdmin={false} />;
};

export default MyAvailability;
